import React, { Component } from "react";
import "./SampleDL.scss";
import DLFront from "../../../assets/docSampleImages/DL FRONT.jpg";
import DLBACK from "../../../assets/docSampleImages/DL BACK.jpg";
import BottomPanel from "../../BottomPanel/BottomPanel";
export interface ISampleDLMobileViewProps {
  setShowPopup: Function;
  showPopup: boolean;
  text?: any;
  children?: any;
}
const SampleSDLMobileViewProps = (props: ISampleDLMobileViewProps) => {
  const getMobileUIPopup = () => {
    return (
      <div className="mobile-view">
        <span className="mobile-view-text">Uploading Driving Licence</span>
        <div className="Aadhar-format-2">
          <span>
            <p className="Aadhar-format-read-more">
              Attach a readable front & back photo of your Driving Licence in
              JPEG or PNG (Max Size: 2MB)
            </p>
            <span className="Aadhar-Front-row">
              <div className="image-container">
                <img
                  src={DLFront}
                  width={130}
                  height={120}
                  className="aadhar-Front-sample document-image" alt="Sample driving license front" />
                <div className="badge">1</div>
              </div>

              <span className="Aadhar-Label">FRONT</span>
            </span>
            <span className="Aadhar-Front-row mt-20">
              <div className="image-container">
                <img
                  src={DLBACK}
                  width={130}
                  height={120}
                  className="aadhar-Front-sample document-image" alt="Sample driving license back" />
                <div className="badge">2</div>
              </div>

              <span className="Aadhar-Label">BACK</span>
            </span>
          </span>
        </div>
      </div>
    );
  };
  return (
    <BottomPanel
      customComponent={getMobileUIPopup}
      setShowSection={props?.setShowPopup}
    />
  );
};
export default SampleSDLMobileViewProps;
